import api from './api';

/**
 * Servicio para gestionar ventas
 */
export const ventasService = {
  /**
   * Obtener todas las ventas
   * @param {number} sucursalId - ID de la sucursal para filtrar (opcional)
   * @param {number} clienteId - ID del cliente para filtrar (opcional)
   * @param {string} fechaDesde - Fecha desde (opcional)
   * @param {string} fechaHasta - Fecha hasta (opcional)
   * @param {string} estatus - Estatus de la venta (opcional)
   */
  getAll: async (sucursalId = null, clienteId = null, fechaDesde = null, fechaHasta = null, estatus = null) => {
    const params = {};
    if (sucursalId) params.sucursalId = sucursalId;
    if (clienteId) params.clienteId = clienteId;
    if (fechaDesde) params.fechaDesde = fechaDesde;
    if (fechaHasta) params.fechaHasta = fechaHasta;
    if (estatus) params.estatus = estatus;
    const response = await api.get('/ventas', { params });
    return response;
  },

  /**
   * Obtener ventas por sucursal
   * @param {number} sucursalId - ID de la sucursal
   * @param {string} fechaDesde - Fecha desde (opcional)
   * @param {string} fechaHasta - Fecha hasta (opcional)
   */
  getBySucursal: async (sucursalId, fechaDesde = null, fechaHasta = null) => {
    const params = {};
    if (fechaDesde) params.fechaDesde = fechaDesde;
    if (fechaHasta) params.fechaHasta = fechaHasta;
    const response = await api.get(`/ventas/sucursal/${sucursalId}`, { params });
    return response;
  },

  /**
   * Obtener una venta por ID
   * @param {number} id - ID de la venta
   */
  getById: async (id) => {
    const response = await api.get(`/ventas/${id}`);
    return response;
  },

  /**
   * Obtener detalle completo de una venta
   * @param {number} id - ID de la venta
   */
  getDetalle: async (id) => {
    const response = await api.get(`/ventas/${id}/detalle`);
    return response;
  },

  /**
   * Crear una nueva venta
   * @param {object} venta - Datos de la venta
   */
  create: async (venta) => {
    const response = await api.post('/ventas', venta);
    return response;
  },

  /**
   * Cancelar una venta
   * @param {number} id - ID de la venta
   * @param {object} cancelacion - Datos de la cancelación
   */
  cancelar: async (id, cancelacion) => {
    const response = await api.post(`/ventas/${id}/cancelar`, cancelacion);
    return response;
  },

  /**
   * Registrar una devolución
   * @param {number} id - ID de la venta
   * @param {object} devolucion - Datos de la devolución
   */
  registrarDevolucion: async (id, devolucion) => {
    const response = await api.post(`/ventas/${id}/devoluciones`, devolucion);
    return response;
  },
};

